export default "__VITE_ASSET__DkKC5ywB__"